
export default {
  emits: ['click-close'],
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click-close');
    },
  },
};
